import { ComponentProps } from 'react';
import { Box } from 'reflexbox';

export default function Section(props: ComponentProps<typeof Box>) {
	return <Box {...props}>{props.children}</Box>;
}
